import Block from '../block';

/**
 * Create the action
 */

const { thunk, request, success, error } = Block.index((version, fetch) => {
    if (version) {
        return fetch.get(`block/version/${version}`);
    }
    return fetch.get('block');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
